import { useState, useEffect } from "react";
import { Alert, Box, Button, FormField, Input, Modal, SpaceBetween, Spinner } from "@cloudscape-design/components";
import { QbilonService } from "../../services/qbilon-service";

export default function DeleteRelationshipModal({
    onOpenSettings,
    onDismiss,
    onSave,
    selectedItems
}) {

    const [value, setValue] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
            <Modal
                visible={onOpenSettings}
                onDismiss={onDismiss}
                header="Beziehung löschen"
                closeAriaLabel="Dialog schließen"
                size={isMobile ? "max" : "medium"}
                footer={
                    <Box float="right">
                        <SpaceBetween direction="horizontal" size="xs">
                            <Button variant="link" onClick={onDismiss} disabled={isLoading}>{isLoading ? <Spinner aria-label="Lädt..." /> : "Abbrechen"}</Button>
                            <Button variant="primary" disabled={value !== "löschen" || isLoading}
                                onClick={async () => {
                                    setError("");
                                    setIsLoading(true);
                                    try {
                                        await QbilonService.deleteEdge(selectedItems[0].id);
                                        onSave?.();
                                        setValue("");
                                    } catch (err) {
                                        setError(err?.message ?? "Fehler beim Löschen der Beziehung");
                                    } finally {
                                        setIsLoading(false);
                                    }
                                }}
                            >{isLoading ? <Spinner aria-label="Löscht..." /> : "Löschen"}</Button>
                        </SpaceBetween>
                    </Box>
                }
            >
                <SpaceBetween size="m" direction="vertical">
                    <Box>{'Sind Sie sicher, dass Sie diese Beziehung löschen möchten?'}</Box>
                    <Alert type="warning">
                        Diese Aktion kann nicht rückgängig gemacht werden.
                    </Alert>
                    {error && (
                        <Alert type="error" dismissible onDismiss={() => setError("")}>
                            {error}
                        </Alert>
                    )}
                    <FormField
                        label="Bestätigung"
                        description="Bitte geben Sie 'löschen' ein, um zu bestätigen."
                        constraintText="Pflichtfeld"
                        errorText={value && value !== "löschen" ? "Bitte 'löschen' eingeben" : ""}
                    >
                        <Input
                            onChange={({ detail }) => setValue(detail.value)}
                            value={value}
                            placeholder="löschen"
                            invalid={value !== "" && value !== "löschen"}
                            ariaRequired={true}
                        />
                    </FormField>
                </SpaceBetween>
            </Modal>
        </>
    )
}